<template>
  <div
    v-if="loadingMessages.length > 0"
    class="loader"
  >
    <div class="content">
      <v-progress-circular
        :indeterminate="true"
        :size="50"
      />
      <div class="text">
        <p>{{ loadingMessages[loadingMessages.length-1].text }}</p>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ScreenLoader',
    data: () => ({
    }),
    computed: {
      loadingMessages () {
        return this.$store.state.general.loadingMessages
      },
    },
    watch: {
    },
    mounted: function () {
    },
    methods: {
    },
  }
</script>

<style lang="scss">
.loader {
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: rgba(50, 50, 50, 0.8);
  z-index: 99999;
  .content {
    margin-top: 25%;
    margin-left: 50%;
    align-items: center;
    p{
      font-size: 20px;
    }
  }
}
</style>
